import React from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

const WhiteElephantDialog = ({ open, onClose }) => {
    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                4th Annual Honky Tonk White Elephant
                <IconButton
                    onClick={onClose}
                    sx={{ color: 'grey.500' }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                    <img width="350" src="/images/white-elephant.gif" alt="White Elephant Dance" style={{ maxWidth: '100%' }}/>
                </Box>
                <Typography variant={"body1"} gutterBottom>
                    Its that time of year again for our annual white elephant gift exchange!
                </Typography>
                <Typography variant={"body1"} gutterBottom>
                    Dress up in your favorite festive attire (optional), and head down to White Horse on Tuesday, with a wrapped gift! To keep things casual, we recommend a $20 limit.
                </Typography>
                <Typography variant={"body1"} gutterBottom>
                    After Missy Beth's last song, meet us on the patio, exchange your gift for a number and let the games begin!
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default WhiteElephantDialog;